import { useNavigate } from "react-router-dom";
import { Eye, ArrowLeft } from "lucide-react";

export default function PreviewCustomer() {
  const navigate = useNavigate();
  return (
    <div className="animate-fade-up" data-testid="owner-preview-page">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-[#b0862f]/40 bg-[#b0862f]/10 px-4 py-3" data-testid="preview-banner">
        <div className="flex items-center gap-2 text-[13px] font-semibold text-[#8a6620]">
          <Eye size={16} /> Customer Preview — read-only demonstration using clearly labeled sample (SANDBOX) data. You are not impersonating a real customer.
        </div>
        <button onClick={() => navigate("/owner")} data-testid="return-owner-btn"
          className="inline-flex items-center gap-1.5 rounded-lg bg-[#080d1a] px-3 py-1.5 text-[12px] font-semibold text-white">
          <ArrowLeft size={14} /> Return to Owner Portal
        </button>
      </div>
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white" style={{ height: "calc(100vh - 180px)" }}>
        <iframe title="Customer Preview" src="/home?preview=1" className="h-full w-full" data-testid="preview-frame" />
      </div>
    </div>
  );
}
